import React, { PropsWithChildren, useState } from "react";

interface CollapsibleProps {
	title: string;
	right?: React.ReactElement;
}

const Collapsible: React.FC<PropsWithChildren<CollapsibleProps>> = (props) => {
	const [open, setOpen] = useState(true);
	return (
		<>
			<div
				className={
					"p-2 bg-base-200 cursor-pointer border-b border-border-base-300 text-white font-bold flex justify-between items-center select-none"
				}
				onClick={() => setOpen(!open)}
			>
				{props.title}
				{props.right}
			</div>
			<div className={"overflow-y-hidden " + (!open ? "h-0" : "")}>{props.children}</div>
		</>
	);
};

export { Collapsible };
